import * as React from "react";
import { forwardRef } from "react";
const SvgSend = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", height: "current", viewBox: "0 0 50 50", xmlSpace: "preserve", ref, ...props }, /* @__PURE__ */ React.createElement("g", { transform: "matrix(1.6288 0 0 1.6288 24.9321 24.9321)", id: 248644 }, /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "current",
  strokeWidth: 1,
  strokeDasharray: "none",
  strokeLinecap: "butt",
  strokeDashoffset: 0,
  strokeLinejoin: "miter",
  strokeMiterlimit: 4,
  isCustomFont: "none",
  fontFileUrl: "none",
  fill: "current",
  fillRule: "nonzero",
  opacity: 1
}, vectorEffect: "non-scaling-stroke", transform: " translate(-16.0004, -15.9999)", d: "m 11.554 20.446 l 4.264 9.948 a 0.999 0.999 0 0 0 0.9 0.606 h 0.02 a 1 1 0 0 0 0.903 -0.572 l 13.262 -28 a 0.998 0.998 0 0 0 -1.33 -1.331 l -28 13.262 a 1 1 0 0 0 0.033 1.823 l 9.948 4.264 z M 27.897 4.103 L 16.783 27.568 l -3.549 -8.277 a 0.995 0.995 0 0 0 -0.525 -0.525 l -8.277 -3.55 L 27.897 4.104 z", strokeLinecap: "round" })));
const ForwardRef = forwardRef(SvgSend);
export default ForwardRef;
